import { createContext } from 'react';
import { NOOP } from '@testsigma/atoms';

interface WindowsAdvancedElementsContext {
  currentPopup: any;
  updateCurrentPopup: Function;
  isWindowsAdvanced: boolean;
  updateIsWindowsAdvanced: Function;
  isImporting: boolean;
  updateIsImporting: Function;
  currentElementFile: any;
  updateCurrentElementFile: Function;
  isUploading: boolean;
  updateIsUploading: Function;
  handleUpload: Function;
  uftCurrentImportItem: any;
  updateUFTCurrentImportItem: Function;
}

const windowsAdvancedElementsContext: WindowsAdvancedElementsContext = {
  currentPopup: null,
  isWindowsAdvanced: false,
  isImporting: false,
  currentElementFile: null,
  updateCurrentPopup: NOOP,
  updateIsImporting: NOOP,
  updateCurrentElementFile: NOOP,
  updateIsWindowsAdvanced: NOOP,
  isUploading: false,
  updateIsUploading: NOOP,
  handleUpload: NOOP,
  uftCurrentImportItem: null,
  updateUFTCurrentImportItem: NOOP,
};

const WindowsAdvancedElementsContext = createContext(
  windowsAdvancedElementsContext,
);
export { WindowsAdvancedElementsContext };
